import {useSharedDispatch} from '@deliveryhero/vendor-web-core';
import {useEffect} from 'react';
import {usePlatforms} from '../../hooks/usePlatforms';
import {AVAILABILITY_ENABLED} from '../../slices/AvailabilityStateSlice';

export const AvailabilityEnablingDaemon = ({
  isApiGatewayUrlDefined,
}: {
  isApiGatewayUrlDefined: boolean;
}): JSX.Element | null => {
  const dispatch = useSharedDispatch();
  const platforms = usePlatforms();
  // Our backend currently supports processing up to 130 restaurants.
  // For stability, limit platform checks to 100 to avoid exceeding backend capacity.
  // Reference: https://deliveryhero.slack.com/archives/C03892MTG83/p1732698309239769?thread_ts=1732021910.168689&cid=C03892MTG83
  const isAvailabilityEnabled =
    platforms.length >= 1 && platforms.length <= 100 && isApiGatewayUrlDefined;

  useEffect(() => {
    dispatch({
      type: AVAILABILITY_ENABLED,
      payload: {isEnabled: isAvailabilityEnabled},
    });
  }, [dispatch, isAvailabilityEnabled]);

  return null;
};
